import store from "../../../../store";
import { has } from "../../../../utils/menu-context";
import { callCompanyCalendarStatus } from "./company-calendar.section";

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            if (has({ menuContext, key: "forCompanyOfficer" })) {
                result = ["Draft", "Postpone", "Approve"].includes(record.refStatus?.key) || result;
            }
            if (has({ menuContext, key: "forCompany" })) {
                result = ["Wait"].includes(record.refStatus?.key) || result;
            }
            return result;
        },
        canSendWait: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forCompanyOfficer" })) {
                result = ["Draft"].includes(record.refStatus?.key) || result;
            }
            return result;
        },
        canApproveReview: ({ record }) => {
            let result = false;
            const userInfo = store.state.resource.auth.info?.user;
            if (record.refInspector?.username === userInfo?.username) {
                result = ["Approve"].includes(record.refStatus?.key) || result;
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refStatus"].includes(field?.key);
            },
            visibleField: ({ props, initialModel }) => {
                const { menuContext } = props;
                let visible = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    visible = ["Postpone", "Approve", "Approve Review", "Cancel"].includes(initialModel.refStatus?.key) || visible;
                }
                if (has({ menuContext, key: "forCompany" })) {
                    visible = ["Wait", "Postpone", "Approve", "Approve Review", "Cancel"].includes(initialModel.refStatus?.key) || visible;
                }
                return visible;
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                let list = undefined;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if (["Postpone"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                    if (["Postpone", "Approve", "Approve Review", "Cancel"].includes(initialModel.refStatus?.key)) {
                        list = ({ searchQuery }) =>
                            callCompanyCalendarStatus({ searchQuery }).then(statuses => statuses.filter(d => ["Approve", "Approve Review", "Cancel"].includes(d.key)));
                    }
                }
                if (has({ menuContext, key: "forCompany" })) {
                    if (["Wait"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                    if (["Approve", "Approve Review", "Cancel"].includes(initialModel.refStatus?.key)) {
                        list = ({ searchQuery }) =>
                            callCompanyCalendarStatus({ searchQuery }).then(statuses => statuses.filter(d => ["Approve", "Approve Review", "Cancel"].includes(d.key)));
                    }
                }
                return { disabled: !enabled, list };
            }
        },
        {
            check: ({ field }) => {
                return ["appointmentPostponeDatetime"].includes(field?.key);
            },
            visibleField: ({ props, initialModel }) => {
                const { menuContext } = props;
                let visible = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    visible = ["Postpone", "Approve", "Approve Review", "Cancel"].includes(initialModel.refStatus?.key) || visible;
                }
                if (has({ menuContext, key: "forCompany" })) {
                    visible = ["Wait", "Postpone", "Approve", "Approve Review", "Cancel"].includes(initialModel.refStatus?.key) || visible;
                }
                return visible;
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompany" })) {
                    if (!["Postpone"].includes(initialModel.refStatus?.key) && ["Postpone"].includes(modelRef.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                    if (["Wait"].includes(initialModel.refStatus?.key)) {
                        if (!["Postpone"].includes(modelRef.refStatus?.key)) {
                            modelRef.appointmentPostponeDatetime = null;
                        }
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["companyRemark"].includes(field?.key);
            },
            visibleField: ({ props, initialModel }) => {
                const { menuContext } = props;
                let visible = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    visible = ["Postpone", "Approve", "Approve Review", "Cancel"].includes(initialModel.refStatus?.key) || visible;
                }
                if (has({ menuContext, key: "forCompany" })) {
                    visible = ["Wait", "Postpone", "Approve", "Approve Review", "Cancel"].includes(initialModel.refStatus?.key) || visible;
                }
                return visible;
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    //
                }
                if (has({ menuContext, key: "forCompany" })) {
                    if (["Wait"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refCompany", "refInspector", "refInspectionType", "isInvestFollowup", "appointmentDatetime", "desc"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if ([undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (has({ menuContext, key: "forCompany" })) {
                    //
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refCompanyInspection.refInspector",
                    "refCompanyInspection.refInspectionType",
                    "refCompanyInspection.isInvestFollowup"
                ].includes(field?.key);
            },
            visibleField: () => {
                return false;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyProduct"].includes(sectionKey);
            },
            visibleSection: ({ props, initialModel }) => {
                const { menuContext } = props;
                let visible = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if (["Approve", "Approve Review"].includes(initialModel.refStatus?.key)) {
                        visible = true;
                    }
                }
                return visible;
            },
            componentProp: () => {
                return {
                    viewOnly: true,
                    disabledSamplingCondition: true,
                    disabledSamplingFrequencyType: true,
                    disabledStatus: true,
                    disabledRemark: true,
                    visibleCheckPrivilege: false,
                    visibleCheckReject: false,
                    visibleIsSuspendedSampling: false,
                    visibleIsSuspendedHc: false,
                    visibleDocRejectStatus: false
                };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyCountry"].includes(sectionKey);
            },
            visibleSection: ({ props, initialModel }) => {
                const { menuContext } = props;
                let visible = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if (["Approve", "Approve Review"].includes(initialModel.refStatus?.key)) {
                        visible = true;
                    }
                }
                return visible;
            },
            componentProp: () => {
                return {
                    viewOnly: true,
                    disabledStatus: true
                };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["Inspection"].includes(sectionKey);
            },
            visibleSection: ({ props, initialModel }) => {
                const { menuContext } = props;
                let visible = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if (["Approve", "Approve Review"].includes(initialModel.refStatus?.key)) {
                        visible = true;
                    }
                }
                return visible;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["Inspection"].includes(sectionKey);
            },
            visibleSection: ({ props, initialModel }) => {
                const { menuContext } = props;
                let visible = false;
                if (has({ menuContext, key: "forCompanyOfficer" })) {
                    if (["Approve", "Approve Review"].includes(initialModel.refStatus?.key)) {
                        visible = true;
                    }
                }
                return visible;
            }
        }
    ];
};
